<template>
  <div id="sub">
    <nav>
      <h2>Sub Menu</h2>
      <ul class="submenu">
        <li v-for="subMenu in subMenuList" :key="subMenu.id">
          <router-link :to="subMenu.menuURL">{{ subMenu.menuName }}</router-link>
        </li>
      </ul>
    </nav>
    <section class="box">
      <p class="c">
        <span v-for="credit in creditList" :key="credit.id">
          <h2 v-if="credit.type == 'name'">{{ credit.text }}</h2>
          <strong v-if="credit.type == 'title'">{{ credit.text }}</strong>
          <br v-if="credit.type == 'address'">
          <span v-if="credit.type == 'address'" v-text="credit.text"></span>
        </span>
      </p>
    </section>
  </div><!--/sub-->
</template>

<script>
export default {
  computed: {
    subMenuList() {
      return this.$store.getters.getSubMenuList;
    },
    creditList() {
      return this.$store.getters.getCreditList;
      // return this.$store.getters["database"];
    },
  },
};
</script>
